import { render, staticRenderFns } from "./ContentSlider.vue?vue&type=template&id=503ee5fa&scoped=true&"
import script from "./ContentSlider.vue?vue&type=script&lang=js&"
export * from "./ContentSlider.vue?vue&type=script&lang=js&"
import style0 from "./ContentSlider.vue?vue&type=style&index=0&id=503ee5fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503ee5fa",
  null
  
)

export default component.exports